import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sanitize      from '@utils/sanitize';

import ContentsModal from 'contents_modal';

import diff_m        from 'diff-match-patch-node';

import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
// -------------------------------------------------------

const CUT_IMAGE_WIDTH = 120;

class DraftDetailPreviewModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    let draft_id = null;
    try {
      let historys = this.getHistory.bind(this)();
      draft_id = historys[0].draft_id;
    } catch(e) {console.log(e)};
    
    this.state = {
      version: draft_id,
    };
  }
  // -------------------------------------------------------
  
  setVersion(ver) {
    this.setState({ version: ver });
  }
  // -------------------------------------------------------
  
  getHistory() {
    let detail   = this.props.detail;
    let contents = this.props.contents;
    let table    = this.props.table;
    
    // 過去バージョンデータの取得
    let historys = [];
    try {
      if( table == 'draft_caption' ){
        historys = detail.draft_caption_history[contents.id];
      } else {
        let checkList = [contents.id];
        if( contents.parent_media_id != null ) checkList.push(contents.parent_media_id);
        
        detail.draft_media_history[contents.contents_id].map((d) => {
          if( checkList.indexOf(d.id) >= 0 || checkList.indexOf(d.parent_media_id) >= 0 ){
            historys.push(d);
            
            checkList.push(d.id);
            if( d.parent_media_id != null ) checkList.push(d.parent_media_id);
          }
        });
      }
    } catch(e) {}
    historys = Utils.sort(historys, 'draft_id', 'desc');
    
    // 現在を抜いたバージョンの表示
    historys = historys.filter((d) => { if( d.draft_id <= contents.draft_id ) return d; });
    return historys;
  }
  // -------------------------------------------------------
  
  render() {
    let base     = this.props.base;
    let detail   = this.props.detail;
    let contents = this.props.contents;
    let table    = this.props.table;
    
    let is_guest = false;
    try { if( base.userData.is_guest == 1 ) is_guest = true; } catch(e) {};
    
    //console.log(detail);
    //console.log(contents);
    
    let historys = this.getHistory.bind(this)();
    let old_historys = historys.filter((d) => { if( d.draft_id != contents.draft_id ) return d; });
    
    let all_historys = [];
    try { all_historys = detail.draft_media_history[contents.contents_id]; } catch(e) {}
    
    return (
      <div className="draft-detail-preview-modal-box">
        <ContentsModal
          view      = {this.props.view}
          width     = {'calc(100% - 200px)'}
          height    = {'calc(100% - 110px)'}
          max_width = {800}
          close_ev  = {this.props.close_ev.bind(this, false)}
          html      = {
            <div className="modal-item draft-detail-preview-modal">
              <div className="preview-box">
                <PreviewContents detail={detail} contents={contents} historys={historys} draft_id={contents.draft_id} mode="contents" set_ev={this.setVersion.bind(this)} />
                <PreviewContents detail={detail} contents={contents} historys={old_historys} draft_id={contents.draft_id} mode="revise" change_ev={this.props.change_ev.bind(this)} />
              </div>
              <PrevPreview is_guest={is_guest} version={this.state.version} contents={contents} historys={historys} all_historys={all_historys} />
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class PrevPreview extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal: false,
      select_id: null,
    };
  }
  // -------------------------------------------------------
  
  toggleModal(flg) {
    this.setState({ modal: flg, select_id: null });
  }
  // -------------------------------------------------------
  
  select(select_id) {
    this.setState({ select_id: select_id });
  }
  // -------------------------------------------------------
  
  submit() {
    let contents = this.props.contents;
    //console.log(contents.id);
    
    if( contents.parent_media_id != null ){
      let chk = confirm('既に登録済みですが、変更してもよろしいですか？');
      if( chk == false ) return;
    }
    
    let chk2 = confirm('変更時に編集中の内容が破棄されてしまいます。保存後に操作をお願いします。\n実行してもよろしいですか？');
    if( chk2 == false ) return;
    
    Utils.request.bind(this)('/api/draft/update_parent_id', { contents_id: contents.id, parent_id: this.state.select_id },
      function(res){
        alert('変更しました！');
        this.toggleModal.bind(this)(false);
        location.reload();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let version = this.props.version;
    let historys = this.props.historys;
    let all_historys = this.props.all_historys;
    
    let last_history = null;
    historys.map((d) => {
      if( d.draft_id < version && last_history == null ) last_history = d;
    });
    
    //console.log(version);
    //console.log(historys);
    //console.log(last_history);
    
    let prev_historys = [];
    try {
      let last_version = null;
      all_historys.map((d) => { if( d.draft_id < version && (last_version == null || last_version < d.draft_id) ) last_version = d.draft_id; });
      
      all_historys.map((d) => {
        if( d.draft_id == last_version && d.media_url != undefined ) prev_historys.push(d);
      });
    } catch(e) {console.log(e)}
    
    //console.log(prev_historys);
    //console.log(all_historys);
    
    // キャプション
    let caption = null;
    try { if( last_history.caption != undefined && last_history.caption != null ) caption = Sanitize.nl2br(last_history.caption); } catch(e) {}
    
    return (
      <div className="prev-preview">
        { (last_history == null) 
          ? <p className="none-version">古いバージョンがありません</p>
          : <div className="prev-preview-contents">
              <h3>前のバージョン</h3>
              
              { ( last_history.media_url != undefined ) &&
                <div className="prev-image">
                  {(Utils.isVideo(last_history.media_url)) ? <video controls src={last_history.media_url} /> : <img src={last_history.media_url} /> }
                </div>
              }
              
              { ( last_history.media_url == undefined ) &&
                <div className="prev-caption" dangerouslySetInnerHTML={{ __html: caption }} />
              }
              
            </div>
        }
        
        { (prev_historys.length > 0 && this.props.is_guest == false) &&
          <p className="prev-version-button" onClick={this.toggleModal.bind(this, true)}>前バージョンの投稿を設定する</p>
        }
        
        <div className="prev-select-modal-contents">
          <ContentsModal
            view      = {this.state.modal}
            width     = {'80%'}
            height    = {'80%'}
            close_ev  = {this.toggleModal.bind(this, false)}
            html      = {
              <div className="modal-item prev-select-modal">
                <h2>前バージョンの投稿を設定する</h2>
                <h4>(ユーザーが削除&新規登録を行った場合に操作してください)</h4>
                
                <ul>
                  { prev_historys.map((d, key) => {
                    let design = (d.id == this.state.select_id) ? 'on' : 'off';
                    return (
                      <li key={key} className={design} onClick={this.select.bind(this, d.id)}>
                        {(Utils.isVideo(d.media_url)) ? <video controls src={d.media_url} /> : <img src={d.media_url} /> }
                      </li>
                    );
                  })}
                </ul>
                
                <div>
                  {(this.state.select_id == null)
                    ? <p className="button off">登録する</p>
                    : <p className="button" onClick={this.submit.bind(this)}>登録する</p>
                  }
                </div>
              </div>
            }
          />
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

class PreviewContents extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    let draft_id = null;
    try { draft_id = this.props.historys[0].draft_id; } catch(e) {};
    
    this.state = {
      viwe_type        : 'work',
      draft_id         : draft_id,
      is_cut_mode      : false,
      select_cut_image : null,
    };
  }
  // -------------------------------------------------------
  
  changeCutMode() {
    this.setState({ is_cut_mode: (this.state.is_cut_mode == true) ? false : true, select_cut_image: null });
  }
  // -------------------------------------------------------
  
  changeStatus(props) {
    this.setState({ draft_id: this.draft_id.value, is_cut_mode: false, select_cut_image: null });
    this.props.set_ev.bind(this)(this.draft_id.value);
  }
  // -------------------------------------------------------
  
  changeRevise() {
    this.props.change_ev.bind(this)(this.revise_message.value);
  }
  // -------------------------------------------------------
  
  selectCutImage(image) {
    this.setState({ select_cut_image: (this.state.select_cut_image == image) ? null : image });
  }
  // -------------------------------------------------------
  
  secToHMS(seconds) {
    const hh = (`00${Math.floor(seconds / 3600)}`).slice(-2);
    const mm = (`00${Math.floor(seconds % 3600 / 60)}`).slice(-2);
    const ss = (`00${(seconds % 60)}`).slice(-2);
    
    return `${hh}:${mm}:${ss}`;
  }
  // -------------------------------------------------------
  
  render() {
    let detail   = this.props.detail;
    let contents = this.props.contents;
    let historys = this.props.historys;
    let mode     = this.props.mode;
    
    let target = {};
    historys.map((d) => { if( d.draft_id == this.state.draft_id ) target = d; });
    
    // キャプション
    let caption = null;
    try { if( target.caption != undefined && target.caption != null ) caption = Sanitize.nl2br(target.caption); } catch(e) {}

    // 修正内容
    let revise_message = null;
    try { if( target.revise_message != undefined && target.revise_message != null ) revise_message = Sanitize.nl2br(target.revise_message); } catch(e) {}
    
    // カット割り
    let cut_mode = (this.state.is_cut_mode == true) ? 'on' : 'off';
    let cutAry = [];
    if( this.state.is_cut_mode == true ){
      try {
        for( let i = 1; i <= target.movie_cut_count; i++ ){
          let time = Math.round(i * (target.movie_duration / target.movie_cut_count));
          cutAry.push({ img: target.movie_cut_template.replace('X.jpg', i +'.jpg'), time: this.secToHMS.bind(this)(time) });
        }
      } catch(e) {console.log(e)}
    }
    
    let last_history = null;
    historys.map((d) => { if( d.draft_id < this.state.draft_id && last_history == null ) last_history = d; });
    
    let caption_new = [];
    if( mode == 'contents' && target.media_url == undefined ){
       try { caption_new = diff_m().diff_main(last_history.caption, target.caption); } catch(e) {}
    }
    
    //console.log(last_history);
    
    return (
      <div className="preview-item">
        { (mode == 'revise') &&
          <div className="now-revise">
            <h3>現在の修正依頼</h3>
            <textarea className="text" ref={(input) => { this.revise_message = input }} defaultValue={contents.revise_message} onChange={this.changeRevise.bind(this)} />
          </div>
        }
        
        <div className="header">
          { (mode == 'contents' && target.media_url != undefined) && <h3>画像・動画</h3> }
          { (mode == 'contents' && target.media_url == undefined) && <h3>キャプション</h3> }
          { (mode == 'revise' && Object.keys(target).length > 0) && <h3>過去の修正依頼内容</h3> }
          
          { (Object.keys(target).length > 0) &&
            <div className="version">
              <h6>バージョン</h6>
              <div className="selectbox">
                <select ref={(input) => { this.draft_id = input }} onChange={this.changeStatus.bind(this)} defaultValue={this.state.draft_id}>
                  { historys.map((d, key) => {
                    let name = '';
                    try { if( detail.draft_lists[d.draft_id] != undefined) name = ('Ver.'+ detail.draft_lists[d.draft_id].version); } catch(e) {}
		                return <option key={key} value={d.draft_id}>{name}</option>
		              })}
                </select>
              </div>
            </div>
          }
          
          { (target.movie_cut_template != null) && 
            <div className={'cut-mode '+ cut_mode}>
              <p onClick={this.changeCutMode.bind(this)}><i className="material-icons">content_cut</i>コマ割り</p>
            </div>
          }
          
        </div>
        
        { (Object.keys(target).length > 0) &&
          <div className={'ceontents mode-'+ this.props.mode}>
            { (mode == 'contents' && target.media_url != undefined && this.state.is_cut_mode == false ) &&
              <div className="image">
                {(Utils.isVideo(target.media_url)) ? <video controls src={target.media_url} /> : <img src={target.media_url} /> }
              </div>
            }
            
            { (mode == 'contents' && target.media_url != undefined && this.state.is_cut_mode == true ) &&
              <div className="cut-mode">
                <div className="cut-mode-box">
                  <ul className="cut-list" style={{ width: (CUT_IMAGE_WIDTH * cutAry.length) }}>
                    { cutAry.map((d, key) => {
                      return (
                        <li key={key} onClick={this.selectCutImage.bind(this, d.img)}>
                          <img src={d.img} />
                          <p>{d.time}</p>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                
                { (this.state.select_cut_image != null) &&
                  <div className="cut-preview"><img src={this.state.select_cut_image} /></div>
                }
              </div>
            }
            
            { (mode == 'contents' && target.media_url == undefined ) &&
              <div className="caption-box">
                { (caption_new.length == 0)
                  ? <div className="caption" dangerouslySetInnerHTML={{ __html: caption }} />
                  : <div className="msg caption">
                      { caption_new.map((m, mkey) => {
                        try {
                          let _tag = Sanitize.nl2br(m[1]);

                          if( m[0] ==  0 ) return <span key={mkey} dangerouslySetInnerHTML={{ __html: _tag }} />;
                          if( m[0] ==  1 ) return <span key={mkey} className="plus" dangerouslySetInnerHTML={{ __html: _tag }} />;
                          //if( m[0] == -1 ) return <span key={mkey} className="minus" dangerouslySetInnerHTML={{ __html: _tag }} />;
                        } catch(e) {console.log(e)}
                        
                        return null;
                      })}
                    </div>
                }
              </div>
            }
            
            { ( mode == 'revise' && target.is_approval == 0 ) &&
              <div className="caption" dangerouslySetInnerHTML={{ __html: revise_message }} />
            }
            { ( mode == 'revise' && target.is_approval == 1 ) &&
              <div className="is_approval">内容OK</div>
            }
          </div>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftDetailPreviewModal;